import { useTranslation } from 'react-i18next';
import { GiAutoRepair } from 'react-icons/gi';

import { Grid, Stack, Typography } from '@mui/material';

import {
  maintenancePageLabelSx,
  maintenancePageTitleSx,
  maintenancePageWrapperSx,
} from '@components/common/Maintenance/styles/sxProperties';

interface IMaintenanceComponents {
  message: string;
}
export const MaintenanceComponent = ({ message }: IMaintenanceComponents) => {
  const { t } = useTranslation();

  return (
    <Grid container sx={maintenancePageWrapperSx}>
      <Stack
        sx={{
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <GiAutoRepair size="9rem" />
        <Typography sx={maintenancePageTitleSx}>
          {t('common.maintenance.title')}
        </Typography>
        <Typography sx={maintenancePageLabelSx} variant="h2">
          {message ?? ''}
        </Typography>
      </Stack>
    </Grid>
  );
};
